import React from "react";
import FormWrapper from "../component/FormWrapper";
import { Link, useNavigate } from "react-router-dom";
import LF from "../LandingForm/LF";
import Leaders from "pages/Onboarding/Leaders";
import Faculties from "pages/Onboarding/Faculties";
import Recognition from "pages/Onboarding/Recognition/NewRecognitions";
import CampusInfo from "pages/Onboarding/CampusInfo/NewCampusInfo";
import ChatBot from "pages/Onboarding/ChatBot";
import Testimonials from "pages/Onboarding/Testimonials/NewTestimonials";
import Brochu from "pages/Onboarding/Brochures/NewBranding";
import moment from "moment";
import axios from "axios";
import FacultiesForm from "../Faculties/FacultiesForm";
import NewRecognitions from "pages/Onboarding/Recognition/NewRecognitions";
import NewCampusInfo from "pages/Onboarding/CampusInfo/NewCampusInfo";
import NewTestimonials from "pages/Onboarding/Testimonials/NewTestimonials";
import NewBranding from "pages/Onboarding/Brochures/NewBranding";
import TestimonialPreview from "./TestimonialPreview";
import FoundersPreview from "./FoundersPreview";
import FacultiesPreview from "./FacultiesPreview";
import RecognitionsPreview from "./RecognitionsPreview";
import CampusInfoPreview from "./CampusInfoPreview.tsx";
import BrandingPreview from "./BrandingPreview";
import ChatbotPreview from "./ChatbotPreview";
import { showGlobalModal } from "components/GlobalModal";
import Template from "../Template";
import WebsiteTemplate from "components/NewCards/WebsiteTemplate";
import TemplatePreview from "./TemplatePreview";
import { useGlobalState } from "state";
import { Img } from "components";
import TemplateMedia from "../TemplateMedia";
import TemplateMediaPreview from "./TemplateMediaPreview";
import Loader from "components/Loader";
import { API_CONSTANT_ONBOARDING } from "utils";

const SIDEBAR = [
  {
    label: "Your Website",
    route: "/onboarding/instituteInfo",
    value: true,
    component: "",
  },
  {
    label: "School Info",
    route: "/onboarding/instituteInfo",
    value: sessionStorage.getItem("Institute"),
    id: "Institute",
    component: (
      <LF
        handleNavigate={""}
        resetFormData={""}
        titleAndDesNotRequired={true}
        disableForm={true}
      />
    ),
  },
  {
    label: "Founder's Info",
    route: "/onboarding/instituteInfo/founders",
    value: sessionStorage.getItem("founders"),
    id: "founders",
    component: <FoundersPreview />,
  },
  {
    label: "Teachers Info",
    route: "/onboarding/instituteInfo/faculties",
    value: sessionStorage.getItem("faculties"),
    id: "faculties",
    component: <FacultiesPreview />,
    // (
    //   <Faculties
    //     handleNavigate={""}
    //     resetFormData={""}
    //     titleAndDesNotRequired={true}
    //     disableForm={true}
    //   />
    // ),
  },
  {
    label: "Recognitions",
    route: "/onboarding/instituteInfo/recognition",
    value: sessionStorage.getItem("recognitions"),
    id: "recognitions",
    component: <RecognitionsPreview />,
    //  (
    //   <NewRecognitions
    //     handleNavigate={""}
    //     resetFormData={""}
    //     titleAndDesNotRequired={true}
    //     disableForm={true}
    //   />
    // ),
  },
  {
    label: "Template",
    route: "/onboarding/instituteInfo/template",
    value: sessionStorage.getItem("template"),
    id: "template",
    component: <TemplatePreview />,
  },
  {
    label: "Media",
    route: "/onboarding/instituteInfo/templateMedia",
    value: sessionStorage.getItem("templateMedia"),
    id: "templateMedia",
    component: <TemplateMediaPreview />
    // label: "Campus Info",
    // route: "/onboarding/instituteInfo/campusinfo",
    // value: sessionStorage.getItem("campus"),
    // id: "campus",
    // component: <CampusInfoPreview />,
    // (
    //   <NewCampusInfo
    //     handleNavigate={""}
    //     resetFormData={""}
    //     titleAndDesNotRequired={true}
    //     disableForm={true}
    //   />
    // ),
  },
  {
    label: "Chatbot",
    route: "/onboarding/instituteInfo/chatbot",
    value: sessionStorage.getItem("Chatbot"),
    id: "Chatbot",
    component: (
      // <ChatBot
      //   handleNavigate={""}
      //   resetFormData={""}
      //   titleAndDesNotRequired={true}
      //   disableForm={true}
      // />
      <ChatbotPreview />
    ),
  },
  {
    label: "Testimonials",
    route: "/onboarding/instituteInfo/testimonials",
    value: sessionStorage.getItem("testimonials"),
    id: "testimonials",
    component: <TestimonialPreview />,
  },
  {
    label: "Branding",
    route: "/onboarding/instituteInfo/branding",
    value: sessionStorage.getItem("materials"),
    id: "materials",
    component: <BrandingPreview />,
    // (
    //   <NewBranding
    //     handleNavigate={""}
    //     resetFormData={""}
    //     titleAndDesNotRequired={true}
    //     disableForm={true}
    //   />
    // ),
  }
];

const Preview = ({
  handleNavigate,
  resetFormData,
}: {
  handleNavigate;
  resetFormData?: any;
}) => {
  const { setInstData, instData } = useGlobalState();

  let instituteData = null;
  try {
    instituteData = JSON.parse(sessionStorage?.getItem("_DATA_") || "{}");
  } catch (err) { }

  const [loader, setLoader] = React.useState(false);

  // Check if required fields are empty
  const requiredFields = ["Institute", "founders", "faculties", "template", "templateMedia", "Chatbot"];
  const isSubmitDisabled = requiredFields.some(fieldId => {
    const item = SIDEBAR.find(sidebarItem => sidebarItem.id === fieldId);
    return !item?.value || item?.value === "null" || item?.value === "";
  });

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const institute = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "Institute")?.value as any
      );
      const InstituteBranchBasicInfo = await {
        INSTITUTE_TYPE_NAME: institute?.INSTITUTE_TYPE,
        INSTITUTE_BRANCH_NAME: institute?.NAME,
        INSTITUTE_DOMAIN: institute?.DOMAIN_NAME,
        INSTITUTE_ACTIVATION_DATE: moment().format("YYYY-MM-DD"),
        InstituteBranchDetails: {
          INSTITUTE_BRANCH_LOGO: institute?.LOGO?.selectedImage,
          // INSTITUTE_BRANCH_COUNTRY_CODE: institute?.COUNTRY_CODE,
          // INSTITUTE_BRANCH_PHONE: institute?.MOBILE,
          INSTITUTE_BRANCH_EMAIL_ID: institute?.EMAIL,
        },
        InstituteBranchLocation: {
          INSTITUTE_BRANCH_ADDRESS: institute?.GOOGLE_MAP_POSITION?.address,
          INSTITUTE_BRANCH_COUNTRY: institute?.GOOGLE_MAP_POSITION?.country,
          INSTITUTE_BRANCH_STATE: institute?.GOOGLE_MAP_POSITION?.state,
          INSTITUTE_BRANCH_CITY:
            institute?.GOOGLE_MAP_POSITION?.city ||
            institute?.GOOGLE_MAP_POSITION?.state, // delhi case
          INSTITUTE_BRANCH_PINCODE:
            institute?.GOOGLE_MAP_POSITION?.postalCode || "",
          INSTITUTE_BRANCH_PLACE_ID:
            institute?.GOOGLE_MAP_POSITION?.place_id || "",
          INSTITUTE_BRANCH_LONGITUDE: institute?.GOOGLE_MAP_POSITION?.lng,
          INSTITUTE_BRANCH_LATITUDE: institute?.GOOGLE_MAP_POSITION?.lat,
        },
        INSTITUTE_BOARD_TYPE: institute?.BOARD_TYPE,
        INSTITUTE_FOUNDING_DATE: moment(institute?.FOUNDING_DATE).format(
          "YYYY-MM-DD"
        ),
        INSTITUTE_INSTRUCTION_MEDIUM: institute?.INSTRUCTION_MEDIUM,
        INSTITUTE_GRADE_LEVELS: institute?.GRADE_LEVELS,
        INSTITUTE_BRANCH_ADDONS: institute?.ADDON_PROGRAMS,
        TOTAL_STUDENTS_COUNT: +institute?.TOTAL_STUDENTS_COUNT,
        TOTAL_FACULTY_COUNT: +institute?.TOTAL_FACULTY_COUNT,
      };

      const founders = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "founders")?.value as any
      )?.map((item) => ({
        FounderUser: {
          NAME: item?.INSTITUTE_LEADER_NAME,
          GENDER: item?.GENDER,
          COUNTRY_CODE: item?.COUNTRY_CODE,
          MOBILE_NUMBER: item?.INSTITUTE_LEADER_MOBILE,
          EMAIL_ID: item?.INSTITUTE_LEADER_EMAIL,
          PHOTO_URL: item?.INSTITUTE_LEADER_IMAGE?.selectedImage,
        },
        DESCRIPTION: item?.INSTITUTE_LEADER_DESCRIPTION,
        DESIGNATION: item?.INSTITUTE_LEADER_DESIGNATION,
        QUALIFICATION: item?.INSTITUTE_LEADER_QUALIFICATION,
        EXPERIENCE: item?.INSTITUTE_LEADER_EXPERIENCE,
      }));

      const faculties = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "faculties")?.value as any
      )?.map((item) => ({
        FacultyUser: {
          NAME: item?.FACULTY_NAME,
          GENDER: item?.GENDER,
          COUNTRY_CODE: item?.COUNTRY_CODE,
          MOBILE_NUMBER: item?.FACULTY_MOBILE,
          EMAIL_ID: item?.FACULTY_EMAIL,
          PHOTO_URL: item?.FACULTY_IMAGE?.selectedImage,
        },
        FACULTY_SUBJECT: item?.FACULTY_SUBJECT,
        FACULTY_QUALIFICATION: item?.FACULTY_QUALIFICATION,
        FACULTY_EXPERIENCE: item?.FACULTY_EXPERIENCE,
        FACULTY_DESCRIPTION: item?.FACULTY_DESCRIPTION,
      }));

      const recognitions = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "recognitions")?.value as any
      )?.map((item) => ({
        RECOGNITION_IMAGE: item?.RECOGNITION_IMAGE?.selectedImage,
        RECOGNITION_ACHIEVEMENT: item?.RECOGNITION_ACHIEVEMENT,
        RECOGNITION_ISSUED_BY: item?.RECOGNITION_ISSUED_BY,
        RECOGNITION_YEAR: item?.RECOGNITION_YEAR,
        RECOGNITION_DESCRIPTION: item?.RECOGNITION_DESCRIPTION,
      }));

      // const campus = await {
      //   ABOUT_CAMPUS: JSON.parse(
      //     SIDEBAR?.find((item) => item?.id === "campus")?.value as any
      //   )?.[0]?.ABOUT_CAMPUS,
      //   CAMPUS_IMAGE_DETAILS: JSON.parse(
      //     SIDEBAR?.find((item) => item?.id === "campus")?.value as any
      //   )?.map((item) => ({
      //     IMAGE_TAG: item?.IMAGE_FOR,
      //     // "CAMPUS_IMAGE_URL": item?.CAMPUS_IMAGE,
      //     SELECTED_CAMPUS_IMAGES: item?.CAMPUS_IMAGE?.map(
      //       (item) => item?.selectedImage
      //     ),
      //   })),
      // };

      const storedChatbot = await sessionStorage.getItem("Chatbot");

      const createdChatbotAvatar = await sessionStorage.getItem(
        "CreateChatbotAvatar"
      );

      const avatar = await (storedChatbot ? JSON.parse(storedChatbot) : null);
      const createdAvatar = await (createdChatbotAvatar
        ? JSON.parse(createdChatbotAvatar)
        : null);

      const Chatbot = avatar?.AVATAR_INFO_ID
        ? { AVATAR_INFO_ID: avatar.AVATAR_INFO_ID }
        : createdAvatar?.TRAINING_CONTENT_URL
          ? { TRAINING_CONTENT_URL: createdAvatar.TRAINING_CONTENT_URL }
          : {};

      const storedTemplateMedia = await sessionStorage.getItem(
        "templateMediaPayload"
      );

      const templateMedia = await (storedChatbot
        ? JSON.parse(storedTemplateMedia)
        : null);

      const testimonials = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "testimonials")?.value as any
      )?.map((item) => ({
        TESTIMONIALS_IMAGE: item?.TESTIMONIALS_IMAGE?.selectedImage,
        TESTIMONIALS_NAME: item?.TESTIMONIALS_NAME,
        TESTIMONIALS_TESTIMONIAL: item?.TESTIMONIALS_TESTIMONIAL,
      }));

      const materials = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "materials")?.value as any
      )?.map((item) => ({
        MATERIAL_IMAGE: item?.MATERIAL_IMAGE?.selectedImage,
        MATERIAL_TYPE: item?.MATERIAL_TYPE,
        MATERIAL_NAME: item?.MATERIAL_NAME,
        MATERIAL_DESCRIPTION: item?.MATERIAL_DESCRIPTION,
      }));

      const MasterEventId = await JSON.parse(
        SIDEBAR?.find((item) => item?.id === "template")?.value as any
      )?.MASTER_TEMPLATE_ID;

      const payload = await {
        InstituteBranchBasicInfo,
        InstituteBranchFounderDetails: founders,
        InstituteBranchFaculty: faculties,
        InstituteBranchRecognitions: recognitions,
        TEMPLATE: {
          MASTER_TEMPLATE_ID: MasterEventId,
          WEBSITE_CONTENT_FORMAT: templateMedia,
        },
        // Campus: [campus],
        ChatBotConfig: Chatbot,
        Testimonials: testimonials,
        Branding: materials?.filter((item) => !!item?.MATERIAL_NAME),
        CREATION_DATETIME: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      };
      console.log("payload ", payload);
      try {
        const response = await axios.post(
          `${API_CONSTANT_ONBOARDING}/master/onboarding/process`,
          payload
        );
        if (["200", "201"]?.includes(String(response?.data?.code))) {
          setInstData(response?.data?.data);
          sessionStorage.setItem(
            "_DATA_",
            JSON.stringify(response?.data?.data)
          );
          showGlobalModal(
            response?.data?.message || "Details saved successfully!",
            "success",
            {
              showConfirm: true,
              onConfirm: () => {
                window.location.href = "/onboarding/autoConnectHub";
              },
              confimLabel: "Continue",
            }
          );
        } else {
          showGlobalModal(response?.data?.message, "error");
        }
      } catch (err) {
        showGlobalModal(err?.message, "error");
      } finally {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };

  return (
    <FormWrapper
      childern={
        <div className="relative">
          <div className="bg-onboardingBackground rounded-3xl p-6 text-white">
            <div className="flex flex-col gap-2 justify-center items-center mb-3">
              <p className="text-[4vh] font-bold bg-clip-text text-white text-center">
                Review and Confirm Your Data
              </p>
              <div className="w-full text-center">
                <p className="text-[2vh] font-thin text-white">
                  Please review all the data carefully before submiting.
                </p>
              </div>
            </div>
            {SIDEBAR?.slice(1)?.map((item, index) => {
              // Check if this item is required and empty
              const isRequired = requiredFields.includes(item.id);
              const isEmpty = !item?.value || item?.value === "null" || item?.value === "";
              const showRedBorder = isRequired && isEmpty;

              return (
                <React.Fragment key={`sidebar-section-${index}`}>
                  {/* Section Header */}
                  <div
                    className={`flex justify-between items-center bg-clip-text text-white border border-solid p-1 rounded-lg ${
                      showRedBorder 
                        ? "border-red-500" 
                        : "border-white"
                    } ${index === SIDEBAR?.slice(1)?.length - 1 ? "my-8" : "my-3"}`}
                  >
                    <p className="text-[3vh] font-bold">{item?.label} {!!showRedBorder && <span className="text-[red]">*</span>}</p>
                    <Link
                      to={item?.route}
                      className="text-[2vh] border border-black rounded-lg py-1 px-3"
                    >
                      Edit
                    </Link>
                  </div>

                  {/* Section Component */}
                  {item?.component}

                  {/* Section Break */}
                  <div className="my-6 h-1 w-full bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 rounded-full" />
                </React.Fragment>
              );
            })}

          </div>
          {!instituteData?.BRANCH_ID && (
            <div className="flex justify-center my-2">
              {loader ? (
                <Loader />
              ) : (
                <button
                  type="button"
                  disabled={isSubmitDisabled}
                  className={`inline-flex items-center px-4 py-2 text-[2vh] font-medium text-center text-white rounded-lg focus:ring-4 focus:ring-blue-300 focus:outline-none ${
                    isSubmitDisabled
                      ? "bg-gray-400 cursor-not-allowed opacity-50"
                      : "bg-blue-700 hover:bg-blue-800"
                  }`}
                  style={{ color: "white" }}
                  onClick={handleSubmit}
                >
                  {"Confim & Submit"}
                </button>
              )}
            </div>
          )}
        </div>
      }
      formHeading={undefined}
    />
  );
};

export default Preview;